Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _withStyles = require('../themes/withStyles');

var _componentWithNamesOfHOCs = require('../utils/propTypes/componentWithNamesOfHOCs');

var _componentWithNamesOfHOCs2 = _interopRequireDefault(_componentWithNamesOfHOCs);

var _textlike = require('../utils/propTypes/textlike');

var _textlike2 = _interopRequireDefault(_textlike);

var _visuallyHidden = require('../utils/visuallyHidden');

var _visuallyHidden2 = _interopRequireDefault(_visuallyHidden);

var _Heading = require('./Heading');

var _Heading2 = _interopRequireDefault(_Heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {

  /**
   * Sets the aria-hidden HTML attribute - useful for when the text
   * needs to be referenced by id, but not read in the flow of the
   * page. Requires id to be present to be used
   */
  ariaHidden: _propTypes2['default'].bool,

  hasBlockChildren: _propTypes2['default'].bool,
  children: (0, _airbnbPropTypes.or)([_textlike2['default'], (0, _componentWithNamesOfHOCs2['default'])(_Heading2['default'], 'withStyles')]).isRequired,
  /**
   * HTML id for the element - useful for aria references
   *
   * if `aria-hidden` is `true`, "id" is required.
   */
  id: (0, _airbnbPropTypes.requiredBy)('ariaHidden', _propTypes2['default'].string)
}));

var defaultProps = {
  ariaHidden: null, // this must be `null` or `undefined` so `aria-hidden` doesn't render when false
  hasBlockChildren: false,
  id: null
};

/**
 * AccessibleText creates a text block that is only visible to
 * screen readers and not visible to sighted users.
 *
 * AccessibleText should only be used where other attributes or
 * elements are insufficient for screen readers. It should also
 * only be used in places where the text shown is not necessary
 * for sighted users. In cases where the text would be good for
 * sighted users as well, that text should just be visible.
 */
function AccessibleText(_ref) {
  var css = _ref.css,
      ariaHidden = _ref.ariaHidden,
      hasBlockChildren = _ref.hasBlockChildren,
      children = _ref.children,
      id = _ref.id,
      styles = _ref.styles;

  var Tag = hasBlockChildren ? 'div' : 'span';

  return _react2['default'].createElement(
    Tag,
    _extends({
      id: id,
      'aria-hidden': ariaHidden ? true : null
    }, css(styles.accessible)),
    children
  );
}

AccessibleText.componentCategory = 'Core';
AccessibleText.displayName = 'AccessibleText';
AccessibleText.propTypes = propTypes;
AccessibleText.defaultProps = defaultProps;

exports['default'] = (0, _withStyles.withStyles)(function () {
  return {
    accessible: Object.assign({}, _visuallyHidden2['default'])
  };
}, { pureComponent: true })(AccessibleText);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/AccessibleText.js
// module id = 242
// module chunks = 168707334958949